module.exports = __webpack_public_path__ + "static/justin-cunningham-profile-eb46d96e597a77e6dbabf6e7418ade8e.png";